import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'optionPipe'
})
export class OptionPipe implements PipeTransform {
    transform(contentKey: string): string {
        return `financial-obligations.${contentKey
            .split(/\.?(?=[A-Z])/)
            .join('-')
            .toLowerCase()}.title`;
    }
}
